/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EmptySuccessfulResponse } from '../models/empty-successful-response';
import { ListApiResponse } from '../models/list-api-response';
import { SurchargeListItemResponse } from '../models/surcharge-list-item-response';
import { SurchargeUpdateRequest } from '../models/surcharge-update-request';

@Injectable({
  providedIn: 'root',
})
export class PspSurchargeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPspSurchargeList
   */
  static readonly GetPspSurchargeListPath = '/api/web/v1/psps/{psp}/surcharges';

  /**
   * Get surcharges list for given PSP.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_MASTER_DATA'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPspSurchargeList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPspSurchargeList$Response(params: {

    /**
     * PSP Id.
     */
    psp: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ListApiResponse & {
'data'?: Array<SurchargeListItemResponse>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, PspSurchargeService.GetPspSurchargeListPath, 'get');
    if (params) {
      rb.path('psp', params.psp, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListApiResponse & {
        'data'?: Array<SurchargeListItemResponse>;
        }>;
      })
    );
  }

  /**
   * Get surcharges list for given PSP.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_MASTER_DATA'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPspSurchargeList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPspSurchargeList(params: {

    /**
     * PSP Id.
     */
    psp: number;
    context?: HttpContext
  }
): Observable<ListApiResponse & {
'data'?: Array<SurchargeListItemResponse>;
}> {

    return this.getPspSurchargeList$Response(params).pipe(
      map((r: StrictHttpResponse<ListApiResponse & {
'data'?: Array<SurchargeListItemResponse>;
}>) => r.body as ListApiResponse & {
'data'?: Array<SurchargeListItemResponse>;
})
    );
  }

  /**
   * Path part for operation putPspSurchargeUpdate
   */
  static readonly PutPspSurchargeUpdatePath = '/api/web/v1/psps/{psp}/surcharges/{surcharge}';

  /**
   * Update given surcharge.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_MASTER_DATA'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putPspSurchargeUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putPspSurchargeUpdate$Response(params: {

    /**
     * PSP Id.
     */
    psp: number;
    surcharge: number;
    context?: HttpContext
    body: SurchargeUpdateRequest
  }
): Observable<StrictHttpResponse<EmptySuccessfulResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PspSurchargeService.PutPspSurchargeUpdatePath, 'put');
    if (params) {
      rb.path('psp', params.psp, {});
      rb.path('surcharge', params.surcharge, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmptySuccessfulResponse>;
      })
    );
  }

  /**
   * Update given surcharge.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_MASTER_DATA'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putPspSurchargeUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putPspSurchargeUpdate(params: {

    /**
     * PSP Id.
     */
    psp: number;
    surcharge: number;
    context?: HttpContext
    body: SurchargeUpdateRequest
  }
): Observable<EmptySuccessfulResponse> {

    return this.putPspSurchargeUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<EmptySuccessfulResponse>) => r.body as EmptySuccessfulResponse)
    );
  }

}
